// src/utils/authHelpers.js

export const getCurrentUser = () => {
    const userData = localStorage.getItem('user');
    return userData ? JSON.parse(userData) : null;
  };
  
  export const isAdmin = () => {
    const user = getCurrentUser();
    return user?.role === 'admin';
  };
  